import { Reducer, Action } from "redux";
import { ISocialMediaStatusState, KnownAction, REPIQ_SOCIAL_MEDIA_STATUS, SHOW_LOADER } from "./types";

export const reducer: Reducer<ISocialMediaStatusState> = (state: ISocialMediaStatusState | undefined, incomingAction: Action): ISocialMediaStatusState => {
    if (state === undefined) {
        return { socialMediaStatus: [], isLoading: false };
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case REPIQ_SOCIAL_MEDIA_STATUS:
            return {
                ...state,
                socialMediaStatus: action.socialMediaStatus,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
